<template>
	<div
		class="row h-100"
	>
		<div
			class="col-12"
			:class="{'align-self-center': lazyStep === 1}"
		>
			<transition
				:name="step > 0 ? 'slide-fadein-left' : 'slide-fadein-right'"
				mode="out-in"
			>
				<div
					v-if="step===0"
					key="0"
					class="steps-content"
				>
					<g-table-sync
						:app="app"
						:view="view"
						pagination="loadmore"
						:default-limit="12"
						:columns="columns"
						@edit="edit"
					>
						<template
							slot="example"
							slot-scope="item"
						>
							<fa-icon
								:icon="['fas','qrcode']"
							/> {{ seriesMX.parseSerial(item).serial }}
						</template>

						<template
							slot="iva"
							slot-scope="item"
						>
							{{ item.SerieIVA }}%
						</template>

						<template
							slot="irpf"
							slot-scope="item"
						>
							{{ item.SerieIRPF }}%
						</template>

						<template
							slot="actions"
							slot-scope="item"
						>
							<a-button-group
								v-if="$gestios.items(app).auth({
									scopes: [`set.mine`, `set`],
									strict: false,
									item
								}) && edit"
							>
								<a-tooltip placement="top">
									<template slot="title">
										<span>
											<fa-icon
												:icon="['far', 'arrow-down']"
												class="mr-2"
											/>Reducir serie
										</span>
									</template>
									<a-button @click="decreaseSerialN(item)">
										<fa-icon :icon="['far', 'arrow-down']" />
									</a-button>
								</a-tooltip>
								<a-tooltip placement="top">
									<template slot="title">
										<span>
											<fa-icon
												:icon="['far', 'arrow-up']"
												class="mr-2"
											/>Incrementar serie
										</span>
									</template>
									<a-button @click="increaseSerialN(item)">
										<fa-icon :icon="['far', 'arrow-up']" />
									</a-button>
								</a-tooltip>
							</a-button-group>
						</template>
					</g-table-sync>
				</div>

				<div
					v-if="step===1"
					key="1"
				>
					<div class="row align-items-center ">
						<div class="col-12 col-md-6 px-5">
							<img
								src="@/application/assets/images/add_serial.webp"
								class="img-fluid mx-auto"
							>
						</div>
						<div class="col-12 col-md-6">
							<validation-observer v-slot="{ passes, invalid }">
								<form @submit.prevent="passes(save)">
									<div class="d-flex align-items-center">
										<div>
											<h2
												v-if="id === 0"
												class="mb-0 font-weight-bold text-uppercase"
											>
												Nueva serie
											</h2>

											<h2
												v-else
												class="mb-0 font-weight-bold text-uppercase"
											>
												Editar serie
											</h2>

											<h4 class="text-muted mb-3">
												Organiza tus facturas
											</h4>
										</div>

										<div class="ml-auto" />
										<a-tooltip placement="left">
											<template slot="title">
												Siguiente nº de serie
											</template>
											<h5 class="text-primary">
												<fa-icon
													:icon="['fas','qrcode']"
													class="mr-2"
												/>{{ example.serial }}
											</h5>
										</a-tooltip>
									</div>

									<p class="text-justify">
										Categoriza tus tipos de facturas en numeros de serie distintos. Puedes
										crear los numeros de serie que necesites y luego escoger el que necesites a
										la hora de realizar una nueva factura. Cada numero de serie lleva una
										numeración distinta y puede ser personalizada tal como necesites.
									</p>

									<a-divider dashed>
										<fa-icon
											icon="palette"
											class="mr-2"
										/> Personalización
									</a-divider>

									<div class="row">
										<div class="col-4">
											<g-field
												v-model="fields.SeriePrefijo"
												:disabled="loading"
												:app="app"
												:item="id"
												name="SeriePrefijo"
												placeholder=""
												title="Prefijo"
											/>
										</div>

										<div class="col-4">
											<g-field
												v-model="fields.SerieValor"
												:disabled="loading"
												:app="app"
												:item="id"
												name="SerieValor"
												placeholder="Valor"
												title="Valor"
											/>
										</div>

										<div class="col-4">
											<g-field
												v-model="fields.SerieSufijo"
												:disabled="loading"
												:app="app"
												:item="id"
												name="SerieSufijo"
												placeholder=""
												title="Sufijo"
											/>
										</div>
									</div>

									<div class="row mb-2">
										<div class="col-12 text-right font-size-12">
											<i><b class="mr-2">Variables:</b></i>

											<a-tooltip placement="top">
												<template slot="title">
													{{ $moment().format('YYYY') }}
												</template>

												<i class="mr-2"><b>%YYYY:</b> Año</i>
											</a-tooltip>

											<a-tooltip placement="top">
												<template slot="title">
													{{ $moment().format('MM') }}
												</template>

												<i class="mr-2"><b>%MM:</b> Mes</i>
											</a-tooltip>
										</div>
									</div>

									<div
										v-show="example.alert"
										class="row"
									>
										<div class="col-12 text-warning ">
											<fa-icon
												:icon="['fas','exclamation-triangle']"
												class="mr-2 "
											/>
											<span class="text-justify">
												Hay numeros junto al valor incremental de
												la serie que podrían llegar a confundir
											</span>
										</div>
									</div>

									<a-divider dashed>
										<fa-icon
											icon="info"
											class="mr-2"
										/> General
									</a-divider>

									<div class="row">
										<div class="col-12">
											<g-field
												v-model="fields.SerieNombre"
												:disabled="loading"
												:app="app"
												:item="id"
												name="SerieNombre"
												placeholder=""
												title="Nombre"
											/>
										</div>
									</div>

									<div class="row">
										<div class="col-12">
											<g-field
												v-model="fields.SerieDescripcion"
												:disabled="loading"
												:app="app"
												:item="id"
												name="SerieDescripcion"
												placeholder=""
												title="Descripción"
												type="textarea"
											/>
										</div>
									</div>

									<a-divider dashed>
										<fa-icon
											icon="coins"
											class="mr-2"
										/> Impuestos
									</a-divider>

									<div class="row">
										<div class="col-6">
											<g-field
												v-model="fields.SerieIVA"
												:disabled="loading"
												:app="app"
												:item="id"
												name="SerieIVA"
												title="IVA (%)"
											/>
										</div>

										<div class="col-6">
											<g-field
												v-model="fields.SerieIRPF"
												:disabled="loading"
												:app="app"
												:item="id"
												name="SerieIRPF"
												title="IRPF (%)"
											/>
										</div>
									</div>

									<div class="text-muted py-3 d-flex align-items-center">
										<a-button
											type="link"
											@click="step = 0; reset();"
										>
											<fa-icon
												:icon="['fas','chevron-left']"
												class="mr-2"
											/> Cancelar
										</a-button>
										<div class="ml-auto" />
										<a-popconfirm
											title="¿Estas seguro que deseas limpiar todo el formulario?"
											@confirm="() => reset()"
										>
											<a-button
												type="danger"
												class="mr-2"
												:disabled="loading"
											>
												<fa-icon
													:icon="['fas','brush']"
													class="mr-2"
												/> Limpiar
											</a-button>
										</a-popconfirm>

										<a-button
											v-if="id === 0"
											type="primary"
											html-type="submit"
											:disabled="invalid"
											:loading="loading"
										>
											<fa-icon
												:icon="['fas','plus-square']"
												class="mr-2"
											/> Añadir
										</a-button>

										<a-button
											v-else
											type="primary"
											html-type="submit"
											:disabled="invalid"
											:loading="loading"
										>
											<fa-icon
												:icon="['fas','edit']"
												class="mr-2"
											/> Modificar
										</a-button>
									</div>
								</form>
							</validation-observer>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import seriesMX from '../../helpers/series';

export default {
	name: 'SeriesList',
	data() {
		return {
			app: 'series',
			view: 'series_list',
			id: 0,
			step: 0,
			lazyStep: 0,
			loading: false,
			example: {
				serial: '',
				alert: false
			},
			fields: {
				SerieNombre: '',
				SerieDescripcion: '',
				SeriePrefijo: '',
				SerieSufijo: '',
				SerieValor: 1,
				SerieIVA: 0,
				SerieIRPF: 0
			},
			columns: [
				{
					title: 'Nombre',
					index: 'SerieNombre'
				},
				{
					title: 'Siguiente Nº',
					index: 'SerieValor',
					slot: 'example'
				},
				{
					title: 'IVA',
					index: 'SerieIVA',
					slot: 'iva',
					order: true
				},
				{
					title: 'IRPF',
					index: 'SerieIRPF',
					slot: 'irpf',
					order: true
				},
				{
					title: 'Descripción',
					index: 'SerieDescripcion'
				},
				{
					title: ' ',
					slot: 'actions',
					align: 'right'
				},
				{
					title: 'Acciones',
					slot: '_actions',
					align: 'right'
				}
			],
			seriesMX
		};
	},

	watch: {
		'fields.SeriePrefijo': function () {
			this.renderExample();
		},
		'fields.SerieValor': function () {
			this.renderExample();
		},
		'fields.SerieSufijo': function () {
			this.renderExample();
		},
		step(val) {
			setTimeout(() => {
				this.lazyStep = val;
			}, 400);
		}
	},
	created() {
		this.$hub.$on('newSerie', () => {
			this.reset();
			this.id = 0;
			this.step = 1;
		});

		this.renderExample();
	},
	methods: {
		edit(item) {
			this.step = 1;
			this.id = item._EntityId;
		},
		reset() {
			this.fields = {
				SerieNombre: '',
				SerieDescripcion: '',
				SeriePrefijo: '',
				SerieSufijo: '',
				SerieValor: 1,
				SerieIVA: 0,
				SerieIRPF: 0
			};
		},
		renderExample() {
			const result = seriesMX.parseSerial(this.fields);

			this.example.alert = result.alert;
			this.example.serial = result.serial;
		},
		async save() {
			this.loading = true;

			let result;
			if (this.id > 0) {
				result = await this.$gestios.items(this.app).edit({
					params: this.fields,
					id: this.id
				});

				if (result.ok) {
					this.$toast.success('Nº de serie modificado correctamente');
					this.reset();
					this.step = 0;
				}
			} else {
				result = await this.$gestios.items(this.app).add({
					params: this.fields,
					view: this.view
				});

				if (result.ok) {
					this.$toast.success('Nº de serie dado de alta correctamente');
					this.reset();
					this.step = 0;
				}
			}

			this.loading = false;
		},
		async increaseSerialN(serie) {
			this.loading = true;
			await seriesMX.editSerialValue(serie, 'up', false);
			this.loading = false;
		},
		async decreaseSerialN(serie) {
			this.loading = true;
			await seriesMX.editSerialValue(serie, 'down', false);
			this.loading = false;
		}
	}
};
</script>

<style lang="scss">

</style>
